// Vendors
import * as PIXI from 'pixi.js'

export class ReleaseBg extends PIXI.Sprite {
    public zIndex: number = 100;
    constructor(texture: PIXI.Texture) {
        super(texture);
    }
}